import React from 'react';
import PropTypes from 'prop-types';

import { S3HOST } from '../../ApiConstants';
import { path, isEmptyString, buildUrl } from '../../utils';
import view from '../../Enums';

export default class Component extends React.Component {

    getUserName = () => path(this.props.userData,'full_name',path(this.props.userData,'first_name','')+' '+path(this.props.userData,'last_name',''));
    getPhone = () => path(this.props.userData, 'phone');
    getEmail = () => path(this.props.userData, 'email');
    getEarningPotential = () => path(this.props.userData, 'earning_potential');

    getWidth = () => path(this.props.resizeData, 'width');
    getViewMode = () => this.props.viewMode || path(this.props.resizeData, 'view_mode', view.DESKTOP);

    /**
     * Override this member while extending Screen to access translations specific to the child
     */
    translation_key = '###';

    /**
     * Override this member and set it to the Styles Object created for the child
     */
    styles = this.props.styles || {};

    /**
     * Override this member and set it to the Images Object created for the child
     */
    images = {};

    /**
     * @param {String} key  The Key to access in the translations
     * @return              Screen level translation if available for that key or ''
     */
    gc = key => path(this.props.translationsData, `${this.translation_key}.${key}`, '');

    /**
     * @param {String} key  The Key to access in the translations
     * @return              Universal translation if available for that key or null
     */
    guc = key => path(this.props.translationsData, `universal_translations.${key}`, '');

    /**
     * @param {String} key  The Key to access the styles of a particular element
     * @return             Styles Object if exists or {}
     */
    gs = (key) => path(this.styles, `${key}.${this.getViewMode()}`, {});

    /**
     * @param {String} key  The key to access a particular image from the images object in context
     * @return              Image url if exists or null
     */
    gi = key => !isEmptyString(path(this.images, `${key}.${this.getViewMode()}`))
        ? `${S3HOST}/${this.props.translationsData.universal_translations[this.images[key][this.getViewMode()]]}` : null;

    hasPropChanged = (prevProps, ...paths) => paths.some(p => path(this.props, p) !== path(prevProps, p));

}

Component.propTypes = {
    translationsData: PropTypes.object, // to be connected through redux from globalReducer
    resizeData: PropTypes.object, // to be connected through redux from resizeReducer
    userData: PropTypes.object, // to be connected through redux from userReducer
};